package org.lennycodes.hldi.components


import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.css.autoLength
import com.varabyte.kobweb.compose.css.textAlign
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.A
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Section
import org.jetbrains.compose.web.dom.Text
import org.lennycodes.hldi.constants.HLDITheme

@Composable
fun CustomSection(
    title: String? = null,
    subtitle: String? = null,
    modifier: Modifier = Modifier,
    content: @Composable () -> Unit
) {
    Section(
        attrs  = modifier
            .padding(60.px, 20.px)
            .maxWidth(1200.px)
            .margin(0.px, autoLength)
            .toAttrs()
    ) {
        if (title != null) {
            H2(
                attrs = {
                    style {
                        fontSize(36.px)
                        color(HLDITheme.Colors.primary)
                        textAlign(TextAlign.Center)
                        marginBottom(16.px)
                        fontFamily("Playfair Display", "serif")
                    }
                }
            ) {
                Text(title)
            }
        }
        if (subtitle != null) {
            P(
                attrs = {
                    style {
                        fontSize(18.px)
                        color(HLDITheme.Colors.mediumGray)
                        textAlign(TextAlign.Center)
                        marginBottom(48.px)
                        maxWidth(800.px)
                        marginLeft(autoLength)
                        marginRight(autoLength)
                    }
                }
            ) {
                Text(subtitle)
            }
        }
        content()
    }
}

@Composable
fun GradientButton(
    text: String,
    href: String = "#",
    modifier: Modifier = Modifier
) {
    A(
        href = href,
        attrs =
            modifier
                .padding(14.px, 32.px)
                .backgroundColor(HLDITheme.Colors.primary)
                .color(HLDITheme.Colors.white)
                .fontSize(16.px)
                .fontWeight(600)
                .borderRadius(8.px)
                .textDecorationLine(TextDecorationLine.None)
                .display(DisplayStyle.InlineBlock)
                .textAlign(TextAlign.Center)
                /*
                .transition("all 0.3s ease")
                .styleModifier {
                    add("&:hover") {
                        put("background-color", "#2E8B57")
                        put("transform", "translateY(-2px)")
                        put("box-shadow", "0 4px 12px rgba(11, 102, 35, 0.3)")
                    }
                }
                */
                .toAttrs()

    ) {
        Text(text)
    }
}

@Composable
fun OutlinedButton(
    text: String,
    href: String = "#",
    modifier: Modifier = Modifier
) {
    A(
        href = href,
        attrs =
            modifier
                .padding(14.px, 32.px)
                .backgroundColor(HLDITheme.Colors.tranparent)
                .color(HLDITheme.Colors.primary)
                .fontSize(16.px)
                .fontWeight(600)
                .borderRadius(8.px)
                .border(2.px, LineStyle.Solid, HLDITheme.Colors.primary)
                .textDecorationLine(TextDecorationLine.None)
                .display(DisplayStyle.InlineBlock)
                .textAlign(TextAlign.Center)
                /*
                .transition("all 0.3s ease")
                .styleModifier {
                    add("&:hover") {
                        put("background-color", HLDITheme.Colors.primary)
                        put("color", "white")
                        put("transform", "translateY(-2px)")
                    }
                }
                */
                .toAttrs()


    ) {
        Text(text)
    }
}